package dev.lingvo.site.components.editor

internal class EditorSuggestionLoadRequest internal constructor(
    val keyId: String,
)
